import {
  artifactInlineReportPreviewUrl,
  configIdFromPreviewUrl,
} from "@/components/artifacts/artifactReportViewer";
import type { Artifact } from "@/services/api/agentic-v2";
import type { ArtefactReviewItem } from "./types";

function localReportPreviewUrl(configId: string): string {
  return `/pdf?template=report-builder&config=${configId}`;
}

function isEmbeddableUrl(url: string): boolean {
  if (url.startsWith("/")) return true;
  try {
    return new URL(url).origin === window.location.origin;
  } catch {
    return false;
  }
}

/** Resolve a same-origin URL for inline iframe preview. */
export function cheatSheetInlinePreviewUrl(
  artefact: ArtefactReviewItem,
  loaded?: Artifact | null,
): string | null {
  const configId =
    artefact.report_config_id?.trim()
    ?? configIdFromPreviewUrl(artefact.viewer_url)
    ?? configIdFromPreviewUrl(artefact.preview_path);
  if (configId) return localReportPreviewUrl(configId);

  const candidate = artefact.viewer_url ?? artefact.preview_path;
  if (candidate && isEmbeddableUrl(candidate)) return candidate;

  if (loaded) return artifactInlineReportPreviewUrl(loaded);
  return null;
}
